export default __webpack_public_path__ + "static/media/gamevy.f0b95676.svg";